<template>
    <v-container fluid class="py-0 px-0" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
        >
            <v-tab
                v-if="tabApproved"
                key="awarded-quotes"
                :to="{
                    name: 'awarded-quotes',
                }"
            >
                APPROVED QUOTES
            </v-tab>
            <v-tab key="projects" :to="{ name: 'projects' }">
                PROJECTS
            </v-tab>
            <v-tab
                key="generic"
                :to="{
                    name: 'projects-generic',
                }"
            >
                GENERIC
            </v-tab>
            <v-tab
                v-if="tabClosing"
                key="closing"
                :to="{
                    name: 'closing-projects',
                }"
            >
                CLOSING
            </v-tab>
            <v-tab
                :to="{
                    name: 'nomina-projects',
                }"
            >
                PAYROLL PROCESS
            </v-tab>
            <v-tab
                :to="{
                    name: 'project-managers',
                }"
            >
                PROJECT MANAGERS
            </v-tab>
        </v-tabs>
        <v-card flat>
            <v-card-text
                class="overflow-y-auto pa-0 ma-0 mt-3"
                :style="{ height: `${height}px` }"
            >
                <router-view />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import API from '@/services/api'
import { mapMutations } from 'vuex'
export default {
    name: 'ProjectTabs',
    data: () => ({
        loading: true,
        height: 0,
        userRef: {},
        tabClosing: true,
        tabApproved: true,
    }),
    async mounted() {
        try {
            this.loading = true
            const { data: { user } = {} } = (await API.getMyInfo()) || {}
            this.userRef = user || {}
            const permissions = this.userRef?.permissions || []
            if (
                !permissions.includes('archiveProject') &&
                !permissions.includes('comexEvidence') &&
                !permissions.includes('portfolioEvidence') &&
                !permissions.includes('sapEvidence') &&
                !permissions.includes('removeFromSharePointEvicence') &&
                !permissions.includes('ClosingMeetingCompletedEvicence') &&
                this.userRef.role !== 'Project Manager'
            ) {
                this.tabClosing = false
            }
            if (
                !permissions.includes('markQuotesAsAwarded') &&
                !permissions.includes('validationSAP') &&
                !permissions.includes('documentValidation') &&
                !permissions.includes('salesValidation')
            ) {
                this.tabApproved = false
            }
            this.onResize()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
            } = this.$refs
            this.height = window.innerHeight - containerHeight - tabsHeight - 25
        },
    },
}
</script>

<style></style>
